module.exports = __webpack_public_path__ + "fonts/fa-brands-400.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.woff
// module id = 46
// module chunks = 0